import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';

export default function (date: Date, format?: string): string {
    if (!date) {
        return '';
    }

    if (format) {
        dayjs.extend(LocalizedFormat);
        dayjs.locale('fr');
        return dayjs(new Date(date)).format(format);
    }

    return dayjs(new Date(date)).format("DD/MM - HH[h]mm");
}
